exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".head-img[data-v-d2a5ecc6]{width:90%;margin:0 auto;display:block}.van-cell[data-v-d2a5ecc6]:not(:last-child):after{border:none}.van-cell[data-v-d2a5ecc6]{width:90%;margin:0 auto}[data-v-d2a5ecc6] .van-dialog__header{padding-left:10px;padding-right:10px}", ""]);

// exports
